import { groupLifeProposalsService } from '@/services/proposals/group-life';
import { downloadFromSignedUrl } from '@/shared/utils/signed-url.util';
import { useMutation } from '@tanstack/react-query';

/**
 * Gera e baixa o PDF da proposta PME. O conteúdo do documento é montado
 * inteiramente pelo back-end a partir do policyId — o front só dispara a
 * geração e baixa o arquivo pela URL pré-assinada.
 */
export function useGenerateGroupLifeProposalPdf(policyId: string) {
  return useMutation({
    mutationKey: ['group-life-proposal', policyId, 'pdf'],
    // Sem retry: o retry global (1) reenviava o POST de geração inclusive
    // quando a falha era só no download da signed URL, gerando PDF duplicado.
    retry: false,
    mutationFn: async (params?: { downloadFilename?: string }) => {
      const result = await groupLifeProposalsService.generatePdf({ policyId });
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Erro ao gerar o PDF da proposta');
      }
      const filename =
        params?.downloadFilename ??
        result.data.key.split('/').pop() ??
        `documento-${policyId}.pdf`;
      await downloadFromSignedUrl(result.data.url, filename);
      return result.data;
    },
  });
}
